import { ListTemplateCategories, ListTemplateCategoriesVariables } from './__generated__/ListTemplateCategories'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListTemplateCategories($input: ListTemplateCategoriesInputV2!) {
    listTemplateCategories: listTemplateCategoriesV2(input: $input) {
      templateCategories {
        id
        title
      }
      nextCursor
    }
  }
`

export const useListTemplateCategories = (variables: ListTemplateCategoriesVariables) => {
  return useQuery<ListTemplateCategories, ListTemplateCategoriesVariables>(QUERY, {
    fetchPolicy: 'cache-and-network',
    variables
  })
}
